import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";

// components
import CommonInfoTab from "../Common/CommonInfoTab";
import QualificatorApprove from "./QualificatorApprove";
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";

// icons
import InfoIcon from "@mui/icons-material/Info";
import retrievePermission from "../../utils/retrievePermission";


class QualificatorCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            qualificator: null,
            updatePermission: 0,
        };
    }

    async componentDidMount() {
        await this.retrieveQualificator();
        await this.retrieveUpdatePermission();
    }

    async retrieveUpdatePermission() {
        let p = await retrievePermission(
            'QualificatorViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        await this.setState(
            {
                updatePermission: p
            }
        );
    }

    async retrieveQualificator() {
        this.setState(
            {
                qualificator: null
            }
        );
        const url = `qualificator/${this.props.qualificatorId}`;
        const api = new BaseApi();
        let response = await api.get(
            url,
            {}
        );
        this.setState(
            {
                qualificator: response.data
            }
        );
    }

    render() {
        if (!this.state.qualificator) {
            return (<CircularProgress/>)
        }
        return(
            <Stack>
                <CommonInfoTab
                    callBack={this.retrieveQualificator.bind(this)}
                    groups={
                        [
                            {
                                title: 'Данные',
                                icon: <InfoIcon/>,
                                fields: [
                                    {
                                        title: 'Отрасль',
                                        value: this.state.qualificator.industry_focus,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: this.state.updatePermission,
                                            fields: [],
                                            m2mFields: ['industry_focus', ],
                                            baseUrl: 'qualificator',
                                            obj: {
                                                id: this.state.qualificator.id,
                                                industry_focus: this.state.qualificator.industry_focus.map((item) => (item.id))
                                            }
                                        }
                                    },
                                    {
                                        title: 'Тип физики',
                                        value: this.state.qualificator.physic_task_type,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: this.state.updatePermission,
                                            fields: [],
                                            m2mFields: ['physic_task_type', ],
                                            baseUrl: 'qualificator',
                                            obj: {
                                                id: this.state.qualificator.id,
                                                physic_task_type: this.state.qualificator.physic_task_type.map((item) => (item.id))
                                            }
                                        }
                                    },
                                    {
                                        title: 'Уровень задачи',
                                        value: this.state.qualificator.task_level.title,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: this.state.updatePermission,
                                            fields: ['task_level', ],
                                            m2mFields: [],
                                            baseUrl: 'qualificator',
                                            obj: {
                                                id: this.state.qualificator.id,
                                                task_level: this.state.qualificator.task_level.id,
                                            }
                                        }
                                    },
                                    {
                                        title: 'Причина запроса',
                                        value: this.state.qualificator.calculations_purpose,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: this.state.updatePermission,
                                            fields: [],
                                            m2mFields: ['calculations_purpose', ],
                                            baseUrl: 'qualificator',
                                            obj: {
                                                id: this.state.qualificator.id,
                                                calculations_purpose: this.state.qualificator.calculations_purpose.map((item) => (item.id))
                                            }
                                        }
                                    },
                                    {
                                        title: 'Форма отчета',
                                        value: this.state.qualificator.report_form,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: this.state.updatePermission,
                                            fields: [],
                                            m2mFields: ['report_form', ],
                                            baseUrl: 'qualificator',
                                            obj: {
                                                id: this.state.qualificator.id,
                                                report_form: this.state.qualificator.report_form.map((item) => (item.id))
                                            }
                                        }
                                    },
                                    {
                                        title: 'Дополнительные опции',
                                        value: this.state.qualificator.extra_terms,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        fieldFromArray: 'title',
                                        edit: {
                                            permission: this.state.updatePermission,
                                            fields: [],
                                            m2mFields: ['extra_terms', ],
                                            baseUrl: 'qualificator',
                                            obj: {
                                                id: this.state.qualificator.id,
                                                extra_terms: this.state.qualificator.extra_terms.map((item) => (item.id))
                                            }
                                        }
                                    },
                                ]
                            },
                            {
                                title: 'Оценка',
                                icon: <InfoIcon/>,
                                fields: [
                                    {
                                        title: 'Дни',
                                        value: this.state.qualificator.days,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                    },
                                    {
                                        title: 'Цена',
                                        value: this.state.qualificator.price,
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                    },
                                ]
                            }
                        ]
                    }
                />
                <QualificatorApprove
                    qualificator={this.state.qualificator}
                    callBack={this.retrieveQualificator.bind(this)}
                />
            </Stack>
        )
    }
}

export default QualificatorCard